import { combineReducers } from 'redux';

import PostReducer from './posts/postReducer';
import { alertReducer } from './alert/alertReducer';
import { userReducer } from './account/userReducer';
import { loadingReducer } from './loading/loadingReducer';
import { abiReducer } from './abi/abiReducer';
import { botReducer } from './bot/botReducer';
import { apiKeyReducer } from './apiKey/apiKeyReducer';
import { newsReducer } from './news/newsReducer';
import { tokenReducer } from './token/tokenReducer';

const rootReducer = combineReducers({
  PostReducer,
  alertReducer,
  userReducer,
  loadingReducer,
  abiReducer,
  botReducer,
  apiKeyReducer,
  newsReducer,
  tokenReducer
});

export default rootReducer;
